module.exports = __webpack_public_path__ + "logo-1.png?024a79f04191186142edc2006e1bbad0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-1.png
// module id = 139
// module chunks = 0